import { styled } from "~/common/mui";
import type { CMSIframeDTO } from "../../types/dto";
import { makeExternallyStyledElement } from "../../utils/styles";
import { resolveUrl } from "~/utils/url/urlResolver";
import { useOnMount } from "~/common/hooks/useOnMount";

interface Props extends Omit<CMSIframeDTO, "type"> {
  className?: string;
}
const IFRAME_ID = "configuratorIframe";

export const CMSIframe = (props: Props) => {
  const { url, rootStyle, enableIframeResize } = props;
  const configuratorUrl = resolveUrl(url);

  useOnMount(() => {
    if (!enableIframeResize) {
      return;
    }
    window.iFrameResize?.({ log: false }, `#${IFRAME_ID}`);
  });

  return (
    <StyledIframeContainer rootStyles={rootStyle}>
      <iframe className="scha__pdp-iframe" id={IFRAME_ID} scrolling="yes" src={configuratorUrl}></iframe>
    </StyledIframeContainer>
  );
};

const Container = styled("div")({
  overflow: "hidden",
});

const StyledIframeContainer = makeExternallyStyledElement(Container);
